import gql from 'graphql-tag'

export const DeleteCustomerAddress = gql`
    mutation DeleteCustomerAddress($kind: String!) {
        deleteCustomerAddress(kind: $kind)
    }
`
